module.exports = __webpack_public_path__ + "static/media/Attachment 4 - JSSE Business Plan Template.e678b5d6.pdf";